import { coordsEqual, isNullCoords } from '@/utils/MapUtils';



export function patchDirectSelect(DirectSelect) {
	const DirectSelectPatched = { ...DirectSelect };
	
	// DirectSelectPatched.clickInactive = function(state, e) {
	// 	if (e.featureTarget.geometry.type !== Constants.geojsonTypes.POINT) {
	// 		// switch to direct_select mode for polygon/line features
	// 		this.changeMode(Constants.modes.DIRECT_SELECT, {
	// 			featureId: e.featureTarget.properties.id
	// 		});
	// 	} else {
	// 		// switch to simple_select mode for point features
	// 		this.changeMode(Constants.modes.SIMPLE_SELECT, {
	// 			featureIds: [e.featureTarget.properties.id]
	// 		});
	// 	}
	// };
	
	DirectSelectPatched.clickNoTarget = function (state, e) {
		const coords = state.feature.coordinates;
		if(isNullCoords(coords[0]) && isNullCoords(coords[1])) {
			state.feature.updateCoordinate(0, e.lngLat.lng, e.lngLat.lat);
			state.feature.updateCoordinate(1, e.lngLat.lng, e.lngLat.lat);
		} else if(coords.length == 2 && coordsEqual(coords[0], coords[1])) {
			state.feature.updateCoordinate(1, e.lngLat.lng, e.lngLat.lat);
		} else {
			state.feature.addCoordinate(state.feature.coordinates.length, e.lngLat.lng, e.lngLat.lat);
		}
		this.fireUpdate();
		// this.changeMode(Constants.modes.SIMPLE_SELECT);
	};
	
	DirectSelectPatched.clickInactive = function () {
		// this.changeMode(Constants.modes.SIMPLE_SELECT);
	};
	
	DirectSelectPatched.dragFeature = function(state, e, delta) {
		//can't drag whole feature
	};
	
	
	// patched to make it impossible to remove the last two points from a line.
	DirectSelectPatched.onTrash = function(state) {
		state.selectedCoordPaths
		.sort((a, b) => b.localeCompare(a, 'en', { numeric: true }))
		.forEach(id => state.feature.removeCoordinate(id));
		const currCoords = state.feature.getCoordinates()
		if(currCoords.length == 0) {
			state.feature.setCoordinates([[0,0],[0,0]]);
		} else if(currCoords.length == 1) {
			state.feature.setCoordinates([currCoords[0], currCoords[0]]);
		}
		this.fireUpdate();
		state.selectedCoordPaths = [];
		this.clearSelectedCoordinates();
		this.fireActionable(state);
		if (state.feature.isValid() === false) {
			console.log("INVALID LINESTRING")
		}
	};

	
	// DirectSelectPatched.onMouseMove = function(state, e) {
	// 	// call parent
	// 	const result = DirectSelect.onMouseMove.call(this, state, e);
	
	// 	const geojson = state.feature.toGeoJSON();
	// 	if (preventFunction(geojson)) {
	// 		// show pointer cursor on inactive features, move cursor on active feature vertices
	// 		const isFeature = isInactiveFeature(e);
	// 		const onVertex = isOfMetaType(Constants.meta.VERTEX)(e);
	// 		const onMidpoint = isOfMetaType(Constants.meta.MIDPOINT)(e);
	// 		if (isFeature || onMidpoint) this.updateUIClasses({ mouse: Constants.cursors.POINTER });
	// 		else if (onVertex) this.updateUIClasses({ mouse: Constants.cursors.MOVE });
	// 		else this.updateUIClasses({ mouse: Constants.cursors.NONE });
	// 	}
	
	// 	return result;
	// };
	
	return DirectSelectPatched;
}

export default patchDirectSelect;